module.exports = __webpack_public_path__ + "img/icon-ana-tickets.1f9ed6a9.png";